
<div class="agpr-brandColors">
    <div class="agpr-brandColors-header">
        <span class="agpr-brandColors-header-label">
            <label>
                {{ 'Common.brandInformation.color.label' | localize }}
            </label>
            <span
                role="img"
                class="fa-regular fa-circle-info"
                agprTooltip="Common.brandInformation.color.tooltip"
            ></span>
        </span>
        <agpr-color-picker-trigger
            [showFavoriteColors]="true"
            [(isOpen)]="addColorPickerPopoverOpened"
            (valueWithTypeChange)="onColorChange($event)"
        >
            <agpr-button
                [id]="id + 'add'"
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-square-plus'"
                [tooltip]="'Common.brandInformation.color.add'"
                [tooltipPosition]="'top'"
                (click)="addColorPickerPopoverOpened = !addColorPickerPopoverOpened"
                [disabled]="disabled || value?.length >= maxLimit"
            ></agpr-button>
        </agpr-color-picker-trigger>
    </div>

    @if (value?.length) {
        <ul
            class="agpr-brandColors-list"
            agprListKeyboardNavigation
            [list]="value"
        >
            @for (color of value; track $index; let i = $index;) {
                <li class="agpr-brandColors-listItem">
                    <div class="agpr-brandColors-card">
                        <div
                            role="group"
                            class="agpr-brandColors-card-label"
                            [attr.aria-labelledby]="id + '_colorHex_' + i"
                        >
                            <agpr-color-picker-field
                                class="agpr-reportPreferences-colors-input"
                                [id]="id + '_colorPickerButton_' + i"
                                [value]="color.color"
                                [config]="{
                                    applyHueChange: false,
                                    disabled: disabled
                                }"
                                (changes)="addColor($event, i)"
                            ></agpr-color-picker-field>
                        </div>
                        <div class="agpr-brandColors-buttonWrapper">
                            <agpr-button
                                [id]="id + '_remove_' + i"
                                class="agpr-brandColors-button"
                                [style]="buttonTypes.icon"
                                [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                [tooltip]="'Common.brandInformation.color.remove'"
                                [tooltipPosition]="'top'"
                                (click)="removeColor(i)"
                                [disabled]="disabled"
                            ></agpr-button>
                            @let isFavorite = !!color.favorite;
                            @let favoriteClass = 'agpr-brandColors-' + (isFavorite ? 'icon' : 'button');
                            @let favoriteIcon = isFavorite ? 'fa-solid fa-star' : 'fa-regular fa-duotone fa-star';
                            @let favoriteTooltip = isFavorite ? 'Common.brandInformation.color.preferred' : 'Common.brandInformation.color.setPreferred';
                            <agpr-button
                                [id]="id + '_setPreferredColor_' + i"
                                [class]="favoriteClass"
                                [style]="buttonTypes.icon"
                                [icon]="favoriteIcon"
                                [tooltip]="favoriteTooltip"
                                [tooltipPosition]="'top'"
                                (click)="togglePreferredColor(color)"
                                [disabled]="disabled"
                            ></agpr-button>
                        </div>
                    </div>
                </li>
            }
        </ul>
    } @else {
        <agpr-message
            [id]="id + '_noColorsMessage'"
            class="agpr-brandColors-noColorsMessage"
            [severity]="messageSeverity.noContent"
            [bottomMargin]="false"
        >
            {{ 'Common.brandInformation.color.noColorsMessage' | localize}}
        </agpr-message>
    }
</div>



